import {useMemo} from 'react';

import * as ViewHooks from '../../state/views/hooks';
import * as SectionViewTypes from '../../state/views/section/types';

export const useReportSectionProps = (sectionRef: SectionViewTypes.Ref) => {
  const sectionPart = ViewHooks.usePart(sectionRef);

  if (sectionPart.runSetRefs.length === 0) {
    // There's always at least one runset
    throw new Error('invalid state');
  }

  return useMemo(() => {
    return {
      sectionPart,
    };
  }, [sectionPart]);
};
